export default __webpack_public_path__ + "static/media/helpicon.6983dacf.svg";